export class User {
  idUser: number;
  email: string;
  name: string;
  idLanguage: number | null;
  admin: boolean;
  block: boolean;
  confirmEmail: boolean;
  willDelete: number | null;
  theme?: string | null;

  constructor(
    idUser: number,
    email: string,
    name: string,
    idLanguage: number | null,
    admin: boolean,
    block: boolean,
    confirmEmail: boolean,
    willDelete: number | null,
    theme?: string | null,
  ) {
    this.idUser = idUser;
    this.email = email;
    this.name = name;
    this.idLanguage = idLanguage;
    this.admin = admin;
    this.block = block;
    this.confirmEmail = confirmEmail;
    this.willDelete = willDelete;
    this.theme = theme;
  }

  static fromRaw(raw: any): User {
    return new User(
      raw.idUser,
      String(raw.email),
      String(raw.name),
      raw.idLanguage ?? null,
      Boolean(raw.admin),
      Boolean(raw.block),
      Boolean(raw.confirmEmail),
      raw.willDelete ?? null,
      raw.theme ?? null,
    );
  }

  clone(): User {
    return new User(
      this.idUser,
      this.email,
      this.name,
      this.idLanguage,
      this.admin,
      this.block,
      this.confirmEmail,
      this.willDelete,
      this.theme,
    );
  }

  toPayload(): any {
    const payload: any = {
      email: this.email,
      name: this.name,
      idLanguage: this.idLanguage,
      admin: this.admin,
      block: this.block,
      confirmEmail: this.confirmEmail,
      willDelete: this.willDelete,
    };
    if (this.idUser !== 0) {
      payload.idUser = this.idUser;
    }
    if (this.theme !== null) {
      payload.theme = this.theme;
    }
    return payload;
  }
}
